<template>
  <div>
    <div v-if="showImageOverlay" class="overlay">
      <div v-if="loading" class="loading-container">
        <img src="@/assets/images/loading-spinner15.gif" alt="Cogneetiv AI" class="animated-image">
          <br />
        <p>{{ loadingText }}</p>
    </div>
    </div>
    <form @submit.prevent="generateImage">
      <v-text-field 
        v-model="imagePrompt" 
        label="Enter your prompt for the image" 
        required
        clearable
        counter 
        placeholder="Enter your prompt for the image" 
        full-width 
        multi-line
        class="inputarea"
      ></v-text-field>
      <br />
      <v-icon :color="recordingStateColor">mdi-microphone</v-icon>

<v-btn class="btn btn-primary mb-4" @click="promptUserAndStartRecording" v-if="!isRecording">Start</v-btn>
<v-btn class="btn btn-primary mb-4" @click="stopRecording" v-if="isRecording">Listening</v-btn>
      <v-btn class="btn btn-primary mb-4" style="margin-left: 10px;" color="primary" type="submit">Generate Image</v-btn>
    </form>

    <div v-if="generatedImageUrl" class="image-container">
      <v-btn class="mb-4 download-btn" style="text-decoration: none !important;" :href="generatedImageUrl" target="_blank" download="generated-image">Download</v-btn>
      <v-btn class="mb-4 save-btn" @click="saveImage">Save Image</v-btn>
      <v-btn class="mb-4 close-btn" dark @click="generatedImageUrl = false">X</v-btn>
      <h3></h3>
      <img style="margin-top: -130px; padding-block: 60px;" :src="generatedImageUrl" alt="Generated Image" v-if="imageLoaded" />
    </div>

    <!-- <div v-if="loading" class="loading-container">
      <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading2.gif" alt="Loading" />
          <br />
        <p>{{ loadingText }}</p>
    </div> -->
    <br />

    <!-- <form action="https://v2.convertapi.com/convert/png/to/svg?Secret=nGaDSPQT1AjGV26M&download=attachment" method="post" enctype="multipart/form-data">
            <input type="file" name="File" />
            <br />
            <input type="submit" value="Convert file to Vector"/>
        </form>     -->
        <br />
    <div class="saved-images-container">
      <h3></h3>
      <ul class="image-gallery">
        <li v-for="(savedImage, index) in savedImages" :key="index" @click="openLightbox(savedImage, index)">
          <img :src="savedImage.url" alt="Saved Image" />
          <!-- <div class="overlay"><span>{{ savedImage.prompt }}</span></div> -->
        </li>
      </ul>
      <SavedImageList :saved-items="savedImages" @edit-item="editSavedImage" @delete-item="deleteSavedImage"></SavedImageList>

      <!-- Lightbox Placeholder -->
      <div v-if="isLightboxOpen" class="lightbox">
        <img :src="lightboxImage.url" alt="Lightbox Image" />
        <div>{{ lightboxImage.prompt }}</div>
        <v-btn class="mb-4 download-btn" @click="editSavedImage(lightboxIndex)">Edit</v-btn>
        <v-btn class="mb-4 save-btn" @click="deleteSavedImage(lightboxIndex)">Delete</v-btn>
        <v-btn class="mb-4 close-btn" @click="closeLightbox">Close</v-btn>
      </div>
    </div>
    <div v-if="editedImageUrl" class="edited-image-container">
    <img :src="editedImageUrl" alt="Edited Image" />
    <button @click="downloadEditedImage">Download Edited Image</button>
  </div>
    <div v-if="imageEditorOpen" class="image-editor-container">
    <canvas id="canvas" width="800" height="600"></canvas>
    <button @click="addRectangle">Add Rectangle</button>
    <button @click="addCircle">Add Circle</button>
    <button @click="addText">Add Text</button>
    <button @click="saveEditedImage">Save Image</button>
    <button @click="closeImageEditor">Close Editor</button>
  </div>
  <notifications ref="notifications"></notifications>
  </div>
  
</template>

<script>
import submitAudio from '../assets/audio/input5.wav';
import codeCompleteAudio from "../assets/audio/completed.wav";
import SavedImageList from './SavedImageList.vue';
import Notifications from './Notification.vue';
import { fabric } from 'fabric';
export default {
  data() {
    return {
      showImageOverlay: false,
      imageEditorOpen: false,
      canvas: null,
      imagePrompt: '',
      editedImageURL: null,
      generatedImageUrl: null,
      imageLoaded: false,
      loading: false,
      loadingText: 'Generating Image...',
      isRecording: false,
      savedImages: JSON.parse(localStorage.getItem("savedImages") || "[]"),
      editingImageIndex: -1,
      downloadImageUrl: null,
      isLightboxOpen: false,
      lightboxImage: null,
      lightboxIndex: null,
      recordingStateColor: 'green', // Default color
    };
  },
  components: {
  SavedImageList,
  Notifications
},
  mounted() {
    // Trigger the prompt and start recording after the component is mounted
    setTimeout(() => {
      this.promptUserAndStartRecording();
    }, 3000); // 3 seconds after page load
  },
  methods: {
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Female';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

    //   speech.onend = function() {
    //   setTimeout(() => {
    //     Event.$emit('speakModeOn');
    //   }, 4000);
    //  };
    
    },
    openImageEditor() {
      this.imageEditorOpen = true;
      this.canvas = new fabric.Canvas('canvas');
      // Further initialization of the canvas...
    },

    addRectangle() {
      const rect = new fabric.Rect({
        left: 100,
        top: 100,
        fill: 'red',
        width: 60,
        height: 70,
        angle: 45
      });
      this.canvas.add(rect);
    },

    addCircle() {
      const circle = new fabric.Circle({
        radius: 20, fill: 'green', left: 100, top: 100
      });
      this.canvas.add(circle);
    },

    addText() {
      const text = new fabric.IText('Hello world', {
        left: 100,
        top: 100,
        fontFamily: 'Arial',
        fill: '#333',
        fontSize: 20
      });
      this.canvas.add(text);
    },

    saveEditedImage() {
      this.editedImageUrl = this.canvas.toDataURL();
      // Additional logic if needed
      this.closeImageEditor();
    },

    downloadEditedImage() {
      // Logic to download the edited image
      const link = document.createElement('a');
      link.href = this.editedImageUrl;
      link.download = 'edited-image.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    closeImageEditor() {
      this.imageEditorOpen = false;
      // Additional cleanup if needed
    },
    
    promptUserAndStartRecording() {
      // Use speech synthesis to ask the user what they want to create
      this.readOutLoud('What do you want to create?');
      // Wait for 2 seconds after the question, then start recording
      setTimeout(() => {
      this.isRecording = true;
      this.recordingStateColor = 'green'; // Color when recording starts
      this.startRecording();
    }, 2000);
    },
    showNotification(message, type) {
      // Access the Notifications component using ref and call its method
      this.$refs.notifications.addNotification(message, type);
    },
  async generateImage() {
    this.imageLoaded = false;
    if (!this.imagePrompt) {
      alert("Please enter a prompt for the image.");
      this.showNotification("Please enter a prompt for the image.", "alert");
      return;
    }
    this.showImageOverlay = true;
    this.loading = true;
    // const codeCompleteAudio = 'path_to_your_audio_file.mp3'; // Replace with your audio file path
    new Audio(submitAudio).play();

    let seconds = 0;
    this.readOutLoud(`Generating Image...`);
    this.showNotification(this.loadingText, "alert");
    const interval = setInterval(() => {
      this.loadingText = `Generating Image... (${++seconds}s)`;
    }, 1000);

    try {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/generate-image`, {
        method: 'POST',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message: this.imagePrompt }),
      });

      if (!response.ok) {
        throw new Error("Failed to generate image");
      }

      const data = await response.json();
      this.generatedImageUrl = data.imageUrl;
      
      setTimeout(() => {
        this.imageLoaded = true; // This triggers the CSS animation to reveal the image
      }, 3000);

      clearInterval(interval);
      this.loadingText = '';
      new Audio(codeCompleteAudio).play();

      const speechSynthesis = window.speechSynthesis;
      const utterance = new SpeechSynthesisUtterance("Your image has been generated.");
      speechSynthesis.speak(utterance);
      this.showNotification("Your image has been generated.", "success");
      this.showImageOverlay = false;

    } catch (error) {
      console.error('Error generating image:', error);
      alert("There was an error generating the image.");
      clearInterval(interval);
      this.loadingText = '';
    } finally {
      this.loading = false;
    }
  },
  createDownloadableImage(imageUrl) {
      // Logic to create a smaller downloadable image
      // You can use a canvas or a third-party library to resize the image
      // For example:
      const canvas = document.createElement('canvas');
      // const ctx = canvas.getContext('2d');
      // Load image in canvas, resize it and set `downloadImageUrl` to canvas data URL
      this.generatedImageUrl = canvas.toDataURL('image/png');
      
      // For simplicity, let's just set it to the same URL for now
      this.generatedImageUrl = imageUrl;
    },

    startRecording() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.start();

    recognition.onstart = () => {
      this.recordingStateColor = 'blue'; // Color when user is speaking
    };

    recognition.onresult = (event) => {
    
      this.imagePrompt = event.results[0][0].transcript;
      this.recordingStateColor = 'red'; // Color just before submitting
      setTimeout(() => {
        this.generateImage();
        this.isRecording = false;
        this.recordingStateColor = 'blue'; // Reset color after submitting
      }, 1000);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event);
      this.isRecording = false;
    };

    this.isRecording = true;
  },


  stopRecording() {
    this.isRecording = false;
    this.recordingStateColor = 'blue'; // Reset color when stopped
    // Logic to stop recording. This depends on your implementation of SpeechRecognition.
    // If you've stored the instance of SpeechRecognition in a variable, call stop() on it.
  },

  saveImage() {
  const imageToSave = {
    type: 'image', // Specify the type
    prompt: this.imagePrompt,
    url: this.generatedImageUrl
  };

    if (this.editingImageIndex === -1) {
      this.savedImages.push(imageToSave);
  localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
    } else {
      this.$set(this.savedImages, this.editingImageIndex, imageToSave);
      this.editingImageIndex = -1;
    }

    localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
  },

  updateImage() {
    if (this.editingImageIndex !== -1) {
      const updatedImage = {
        prompt: this.imagePrompt,
        url: this.generatedImageUrl
      };

      this.$set(this.savedImages, this.editingImageIndex, updatedImage);
      this.editingImageIndex = -1;
      localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
    }
  },

  editSavedImage(index) {
    const savedImage = this.savedImages[index];
    this.imagePrompt = savedImage.prompt;
    this.generatedImageUrl = savedImage.url;
    this.editingImageIndex = index;
    // Add any additional logic required for editing the image.
  },

  deleteSavedImage(index) {
    this.savedImages.splice(index, 1);
    localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
  },
  
  openLightbox(image, index) {
      this.lightboxImage = image;
      this.lightboxIndex = index;
      this.isLightboxOpen = true;
    },

    closeLightbox() {
      this.isLightboxOpen = false;
      this.lightboxImage = null;
      this.lightboxIndex = null;
    },
}
};
</script>

<style scoped>

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.mdi-microphone {
  top: -7px;
  animation: pulse 1s infinite;
}
.image-container img {
  mask-size: 100% 200%;
  max-width: 100%;
  height: auto;
  /* animation: reveal-image 10s forwards; */
}
@keyframes scan-line {
  from {
    top: -100%;
  }
  to {
    top: 100%;
  }
}

@keyframes reveal-image {
  0% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to bottom, #ff7e5f, #feb47b); /* Warm colors to start */
    mask-position: top;
    background-size: cover;
  }
  25% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to right, #00c6ff, #0072ff); /* Blue hues for scanning */
    background-size: cover;
  }
  50% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to right, #f953c6, #b91d73); /* Pink to deep violet transition */
    background-size: cover;
  }
  75% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to bottom, #76b852, #8DC26F); /* Green, nature-like */
    background-size: cover;
  }
  100% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to bottom, #4b6cb7, #182848); /* Dark blues for completion */
    mask-position: bottom;
    background-size: cover;
  }
}

.image-container {
  margin-top: 20px;
  text-align: center; /* Centering buttons and image */
  top: -20px;
  left: 0;
  right: 0;
  bottom: 0;
    position: fixed;
  z-index: 9999; /* Ensure it's on top of everything */
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  height: 100%;
  background: rgba(12, 22, 27, 0.962);
  /* animation: reveal-image 10s forwards; */
}

.saved-images-container {
    padding: 15px 15px 15px 15px;
    border: 1px solid #1d323b;
    border-radius: 5px;
    margin-top: -30px;
    margin-bottom: 10px;
    max-height: fit-content;
    background: #1d323bc7;
    overflow-y: auto;
    font-size: 19px;
    font-family: 'Nunito Sans', sans-serif;
    box-shadow: rgba(187, 187, 197, 0.05) 0px 20px 40px -12px inset, rgba(236, 235, 235, 0.10) 0px 12px 22px -6px inset;
}

.image-gallery {
  column-count: 3; /* Adjust based on your preference */
  column-gap: 20px;
  margin-left: -10px;
  margin-right: 10px;
  text-decoration: none !important;
}

.image-gallery > li {
  break-inside: avoid;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: none !important;
  list-style: none;
}

/* Lightbox styles */
.lightbox {
  position: fixed;
  width: 60%;
  height: 60%;
  top: 44%;
  left: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  background: linear-gradient(90deg, #0c161bd5, #0c161b8b);
  z-index: 1000; /* Make sure it's above other content */
  border-radius: 10px;
  text-align: center;
}

.image-gallery li img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  border-radius: 5px;
}

.image-gallery li .v-btn {
  opacity: 0.8;
  outline: 1px solid #fff; /* White outline */
  margin: 10px;
  background-color: rgba(0, 0, 139, 0.6); /* Transparent dark blue */
  color: white; /* Text color */
  border: none; /* Remove default border if any */
  border-radius: 4px; /* Optional: for rounded corners */
}

.image-gallery li .v-btn:hover {
  opacity: 1; /* Full opacity on hover */
}

.download-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: -10px;
  opacity: 0.8;
}
.save-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 0px;
  opacity: 0.8;
}
.close-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 10px;
  opacity: 0.8;
}
.overlay2 {
  background: rgba(0, 0, 0, 0.5);
  border: #000;
  border-radius: 10px;
  color: white;
  width: 100%;
  text-align: center;
  padding: 10px 10px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0c161b2f; /* Semi-transparent background */
}
.inputarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-sizing: border-box;
  resize: vertical;
  --glow: drop-shadow(0 0 1px violet);
  filter: var(--glow) brightness(1.5) drop-shadow(0 0 10px violet);
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
  color: #000;
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  width: 800px;
  height: 600px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 600px) {
  .inputarea {
    width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-sizing: border-box;
  resize: vertical;
  --glow: drop-shadow(0 0 1px violet);
  filter: var(--glow) brightness(1.5) drop-shadow(0 0 10px violet);
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
  color: #000;
  }
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
</style>